// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0140ef48","239":"b0cab730","732":"18b63775","952":"c27830df"}[chunkId] + ".chunk.js";
};